export interface ProjectDetailsDto {
    projectAlias: string;
    projectName: string;
    startDate: string;
    endDate: string;
    estimatedCu: null;
    pf: null;
    hh: string;
    uf: string;
    idUser: number;
    nameUser: string;
    typeUser: string;
    listAssigned: ListAssigned[];
    listLastWeek: ListWeek[];
    listCurrentWeek: ListWeek[];
    listProgress: ListProgress[];
    listStages: ListStages[];
    listRisksMatrix: ListRisksMatrix[];
    listMilestones: ListMilestones[];
}

export interface ListAssigned {
    url: URL;
    name: string;
    type: string;
    status: number;
    percentage: number;
    dateStart: string;
    dateEnd: string;
}

export enum URL {
    AvatarDefaultJpg = "avatar_default.jpg",
    NicolasFigueroaJpg = "nicolas_figueroa.jpg",
    PedroGarciaJpg = "pedro_garcia.jpg",
}

export interface ListWeek {
    id: number;
    name: string;
    idindicator: number;
    indicator: string;
    value: number;
}

export interface ListStages {
    id: number;
    name: string;
    state: number;
    dateStart: string;
    dateEnd: string;
    color: string;
}
export interface ListMilestones {
    id: number;
    name: string;
    state: number;
    dateStart: string;
    dateEnd: string;
    sprint: number;
    project_stages_id: number;
    description: string;
}

export interface ListProgress {
    id: number;
    percentReal: number;
    percentPlanned: number;
    total: string;
    dateStart: string;
    dateEnd: string;
}

export interface ListRisksMatrix {
    id: number;
    idStages: number;
    name: string;
    description: string,
    status: number;
    dateStart: string;
    dateEnd: string;
    type: string;
    process: number;
    probability: number;
    impact: number;
    impactDescription: string;
    usersId: number;
}

export interface ViewRisk {
    listImpact: BasicList[],
    listProbability: BasicList[],
    listAssigned: User[]
    listDependence: ListDependence[],
}

export interface BasicList {
    id: string,
    name: string
}

export interface ListDependence {
    id: number,
    name: string,
    real_start_date: string,
    real_end_date: string,
}

export interface User {
    user_id: number,
    username: string,
}